import Debug from './util/debugHelper';

export default class Exception {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player);
    }

    videoNotFound() {
        if ($(this.player.element).length === 0) {
            this.debug.error("ERROR: Video not found.");
            return false;
        }
    }

    captionNotFound() {
        if ($(this.player.element).find("track").length === 0) {
            this.debug.error("ERROR: Caption not found.");
            return false;
        }
    }
}